import { useAuth0 } from "@auth0/auth0-react"

import { loginProviders } from "@config/enums"

import { SYNC_CONTACTS_MODAL } from "../constants"

// FIX 2 (contacts-default): auth0-spa-js rejects getAccessTokenWithPopup() for two very
// different reasons -- (a) the user genuinely closed the popup or it timed out waiting for
// them ("cancelled" popup errors, auth0-spa-js PopupCancelledError/PopupTimeoutError, or a
// plain "Popup closed" / "Timeout" message), and (b) the popup reached Auth0/Google and got a
// real error back (invalid_request, "connection is not enabled", access_denied, unauthorized,
// etc). Both used to render the same "It seems like you canceled..." copy, which hid real
// config/auth problems behind a friendly lie. Only case (a) is a genuine cancel.
const CANCEL_ERROR_CODES = ["cancelled", "timeout", "popup_closed"]
const CANCEL_MESSAGE_PATTERN = /popup (closed|timed? ?out)|timeout/i

const isGenuineCancel = error => {
  if (!error) return true

  const code = String(error.error || error.code || "").toLowerCase()
  if (CANCEL_ERROR_CODES.includes(code)) return true

  const name = String(error.name || "")
  if (/PopupCancelledError|PopupTimeoutError/i.test(name)) return true

  const message = String(error.message || error.error_description || "")
  return CANCEL_MESSAGE_PATTERN.test(message)
}

const errorMessageText = error => {
  const raw =
    error?.error_description || error?.message || error?.error || ""

  // No em-dashes in user-facing copy; fall back to a plain, non-alarming default.
  return raw ? String(raw) : "Something went wrong. Please try again."
}

export const useAccessToken = ({
  setIsGoogleLoading,
  setIsAppleLoading,
  setModalType,
  setErrorMessage,
}) => {
  const { getAccessTokenWithPopup } = useAuth0()

  const getAccessToken = ({ connection, connection_scope }) => {
    return getAccessTokenWithPopup({
      connection,
      connection_scope,
      prompt: "consent",
      access_type: "offline",
    })
      .then(res => res)
      .catch(error => {
        switch (connection) {
          case loginProviders.google:
          case "google-contacts":
            setIsGoogleLoading(false)
            break
          case loginProviders.apple:
            setIsAppleLoading(false)
            break
          default:
            break
        }

        if (isGenuineCancel(error)) {
          setModalType(SYNC_CONTACTS_MODAL.CANCELED)
          return
        }

        // eslint-disable-next-line no-console
        console.error("[SyncContacts] popup auth error", error)
        setErrorMessage && setErrorMessage(errorMessageText(error))
        setModalType(SYNC_CONTACTS_MODAL.AUTH_ERROR)
      })
  }

  return getAccessToken
}
